import { useSyncExternalStore } from 'react';
import type { LngLat } from '../../shared/protocol';

/**
 * Local GPS simulator — lets you drive your own player by tapping the map,
 * instead of using the device's real geolocation. Each browser window controls
 * its own role (one device per team), so two windows = a full two-player game
 * on one machine with no DevTools sensor overrides.
 */
export interface SimState {
  enabled: boolean;
  pos: LngLat | null;
}

let state: SimState = { enabled: false, pos: null };
const subs = new Set<() => void>();
const emit = () => subs.forEach((s) => s());

export const simStore = {
  snapshot: () => state,
  toggle(seed: LngLat) {
    state = { enabled: !state.enabled, pos: state.pos ?? seed };
    emit();
  },
  /** v19 BOLT-086: turn the simulator ON with a starting position (Practice). */
  enable(pos: LngLat) {
    state = { enabled: true, pos };
    emit();
  },
  setPos(pos: LngLat) {
    state = { ...state, pos };
    emit();
  },
  subscribe(cb: () => void) {
    subs.add(cb);
    return () => subs.delete(cb);
  },
};

export function useSim(): SimState {
  return useSyncExternalStore(simStore.subscribe, simStore.snapshot, simStore.snapshot);
}
